<script lang="ts">
	import Image from '$lib/storyblok/components/image.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { SbImage } from '$lib/storyblok/types';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			image: SbImage;
			title: ISbRichtext;
			caption: string;
			text_color: string;
		}>['content'];
		offset?: number;
	}

	let { content, offset = 0 }: Props = $props();
</script>

<article
	use:editable={content}
	class="relative overflow-hidden rounded-[20px] lg:rounded-3xl"
	style="--card-offset: {-offset}"
>
	<div class="img-container">
		<Image
			src={content.image.filename}
			alt={content.image.alt}
			title={content.image.title}
			class="aspect-2/3 w-full select-none rounded-[20px] object-cover lg:aspect-video lg:rounded-3xl"
		/>
	</div>
	<div class="absolute inset-0 rounded-[20px] bg-black/20 lg:rounded-3xl"></div>
	<div class="absolute inset-0 rounded-[20px] p-5 lg:rounded-3xl lg:p-10">
		<h1
			class="select-none font-serif text-[48px]/[100%] tracking-[-.96px] lg:text-[96px]/[100%] lg:tracking-[-1.92px]"
			style="color: {content.text_color || '#FFFFFF'}"
		>
			<SbRichtext text={content.title} />
		</h1>
	</div>
</article>

<style lang="scss">
	article > .img-container {
		transform: translate3d(calc(var(--card-offset) * 100%), 0, 0);
		will-change: transform;

		:global {
			& img {
				transform: scale(1.33);

				@media (min-width: 1920px) {
					transform: scale(1.5);
				}
			}
		}
	}
</style>
